export const CATEGORY_FILTER_OPTIONS = {
    Category_All: null,
    Category_BondAuctions: '8896AA26-A50C-4F8B-AA11-8B3FCCDA1DFD',
    Category_CapitalFlows: 'FA6570F6-E494-4563-A363-00D0F2ABEC37',
    Category_CentralBanks: 'C94405B5-5F85-4397-AB11-002A481C4B92',
    Category_Consumption: 'E229C890-80FC-40F3-B6F4-B658F3A02635',
    Category_EconomicActivity: '24127F3B-EDCE-4DC4-AFDF-0B3BD8A964BE',
    Category_Energy: 'DD332FD3-6996-41BE-8C41-33F277074FA7',
    Category_Holidays: '7DFAEF86-C3FE-4E76-9421-8958CC2F9A0D',
    Category_HousingMarket: '1E06A304-FAC6-440C-9CED-9225A6277A55',
    Category_Inflation: '33303F5E-1E3C-4016-AB2D-AC87E98F57CA',
    Category_InterestRates: '9C4A731A-D993-4D55-89F3-DC707CC1D596',
    Category_LaborMarket: '91DA97BD-D94A-4CE8-A02B-B96EE2944E4C',
    Category_Politics: 'E9E957EC-2927-4A77-AE0C-F5E4B5807C16'
}
